import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import serviceApi from '../../services/serviceApi';
import { arabicErrorFor } from '../../utils/serviceErrorMessages';

const CancelInvoiceModal = ({ show, onHide, invoice, onCancelled }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState(null);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (show) { setReason(''); setError(null); }
  }, [show]);

  const handleSubmit = async () => {
    setError(null);
    setSaving(true);
    try {
      await serviceApi.invoices.cancel(invoice._id, reason.trim() || null);
      onCancelled?.();
      onHide();
    } catch (err) {
      setError(arabicErrorFor(err, 'تعذر إلغاء الفاتورة'));
    } finally {
      setSaving(false);
    }
  };

  if (!invoice) return null;

  return (
    <Modal show={show} onHide={onHide} centered dir="rtl">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '1.1rem', fontWeight: 700, color: '#c62828' }}>
          إلغاء الفاتورة
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger" className="py-2">{error}</Alert>}

        <Alert variant="warning" className="py-2 mb-3" style={{ fontSize: '0.88rem' }}>
          <i className="bi bi-exclamation-triangle me-2" />
          سيتم إلغاء الفاتورة <strong>{invoice.invoiceNumber}</strong> نهائياً.
          هذا الإجراء غير قابل للتراجع.
        </Alert>

        <Form.Group>
          <Form.Label style={{ fontWeight: 600, fontSize: '0.88rem' }}>السبب (اختياري)</Form.Label>
          <Form.Control
            className="touch-input"
            as="textarea"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="يظهر في سجل الفاتورة"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide} disabled={saving}>إغلاق</Button>
        <Button variant="danger" onClick={handleSubmit} disabled={saving}>
          {saving ? <span className="spinner-border spinner-border-sm" /> : 'إلغاء الفاتورة'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelInvoiceModal;
